import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EmployeeMonitorServices from "./EmployeeMonitor.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getEmployeeMonitor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: true,
    });
    const resp = await EmployeeMonitorServices.getEmployeeMonitor(filters);
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR,
      payload: {
        employeeMonitors: resp.data.data,
        employeeMonitorsLength: resp.data.count,
      },
    });
    // setShowModal(false)
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: false,
    });
  }
};

export const validateEmployeeDescriptor = (filters, value, history) => async (dispatch) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_MONITOR,
      payload: true,
    });
    const resp = await EmployeeMonitorServices.validateEmployeeDescriptor(filters);

    if(resp.data.Resultado){
      // toastr.success(messages.successMessage, "", {
      //   progressBar: true,
      //   rtl: true,
      // });
      history.push(
        `/evaluacion-desempenio/monitor-de-evaluación/${
          value.id
        }/${value.nombre}/${
          value.list_funcion &&
          value.list_funcion[0].id
            ? value.list_funcion[0].id
            : "No asignado"
        }/${
          value.list_funcion &&
          value.list_funcion[0].descripcion &&
          value.list_funcion[0].descripcion !== ""
            ? value.list_funcion[0].descripcion
            : "No asignado"
        }/${
          value.Division_List &&
          value.Division_List[0].id
            ? value.Division_List[0].id
            : "No asignado"
        }/${
          value.Division_List &&
          value.Division_List[0].descripcion &&
          value.Division_List[0].descripcion !== ""
            ? value.Division_List[0].descripcion
            : "No asignado"
        }/${
          value.empresa_id &&
          value.empresa_id[0]
            ? value.empresa_id[0]
            : null
        }`
      )
    }else{
      toastr.info(messages.descriptorErrorMessage, "", {
        progressBar: true,
        rtl: true,
      });
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: message,
    });
    toastr.success(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_MONITOR,
      payload: false,
    });
  }
};

export const getEmployeeMonitorById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR_BY_ID,
      payload: true,
    });
    const resp = await EmployeeMonitorServices.getEmployeeMonitorById(id);
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR_BY_ID,
      payload: false,
    });
  }
};

export const saveEmployeeMonitor = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_MONITOR,
      payload: true,
    });
    const resp = await EmployeeMonitorServices.saveEmployeeMonitor(data);
    const { employeeMonitors, employeeMonitorsLength } = getState().employeeMonitor;
    const eEmployeeMonitors = [...employeeMonitors, resp.data];
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR,
      payload: {
        employeeMonitors: eEmployeeMonitors,
        employeeMonitorsLength: employeeMonitorsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_MONITOR,
      payload: false,
    });
  }
};

export const editEmployeeMonitor = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: true,
    });
    const resp = await EmployeeMonitorServices.editEmployeeMonitor(id, data);
    const { employeeMonitors, employeeMonitorsLength } = getState().employeeMonitor;
    employeeMonitors[index] = resp.data;
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR,
      payload: {
        employeeMonitors: employeeMonitors,
        employeeMonitorsLength: employeeMonitorsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: false,
    });
  }
};

export const editEmployeeMonitorGD = (dataGD, setShowModal, editItem, index, exist, type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: true,
    });
    var respGD = {};
    var resp = {};
    if(type===1){
      if(exist){
        respGD = await EmployeeMonitorServices.saveEmployeeMonitorGD(dataGD);
      }
    }else{
      if(exist){
        respGD = await EmployeeMonitorServices.editEmployeeMonitorGD(editItem.evaluacion_archivo_plan_accion_gestor, dataGD);
      }
    }
    if(respGD&&respGD.data&&respGD.data.resultado){
      resp = await EmployeeMonitorServices.editEmployeeMonitor(editItem.id, {
        ...editItem,
        evaluacion_archivo_plan_accion_gestor: respGD.data.resultado.id
      });
    }else{
      resp = await EmployeeMonitorServices.editEmployeeMonitor(editItem.id, editItem);
    }
    const { employeeMonitors, employeeMonitorsLength } = getState().employeeMonitor;
    employeeMonitors[index] = resp.data;
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR,
      payload: {
        employeeMonitors: employeeMonitors,
        employeeMonitorsLength: employeeMonitorsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: false,
    });
  }
};

export const editEmployeeMonitorCheck = (data, id, index, setLoading) => async (dispatch, getState) => {
  try {
    setLoading(true);

    debugger
    const resp = await EmployeeMonitorServices.editEmployeeMonitor(id, data);
    const { employeeMonitors, employeeMonitorsLength } = getState().employeeMonitor;
    employeeMonitors[index] = resp.data;
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR,
      payload: {
        employeeMonitors: employeeMonitors,
        employeeMonitorsLength: employeeMonitorsLength,
      },
    });

    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    console.error(message)
  } finally {
    setLoading(false);
  }
};

export const deleteEmployeeMonitor = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: true,
    });
    await EmployeeMonitorServices.deleteEmployeeMonitor(id);
    const { employeeMonitors, employeeMonitorsLength } = getState().employeeMonitor;
    employeeMonitors.splice(index, 1);
    dispatch({
      type: actions.GET_EMPLOYEE_MONITOR,
      payload: {
        employeeMonitors: employeeMonitors,
        employeeMonitorsLength: employeeMonitorsLength - 1,
      },
    });
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EMPLOYEE_MONITOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_MONITOR,
      payload: false,
    });
  }
};
